/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from "three";
import React, { useRef } from "react";
import { useLoader } from "react-three-fiber";
import { GLTFLoader, GLTF } from "three/examples/jsm/loaders/GLTFLoader";

type GLTFResult = GLTF & {
  nodes: {
    Banners: THREE.Mesh;
  };
  materials: {
    ["Logos.001"]: THREE.MeshStandardMaterial;
  };
};

export default function Model({ ...props }: JSX.IntrinsicElements["group"]) {
  const group = useRef<THREE.Group>();
  const { nodes, materials } = useLoader<GLTFResult>(
    GLTFLoader,
    "gltf/patros/Patros.gltf",
  );
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        geometry={nodes.Banners.geometry}
        material={materials["Logos.001"]}
        position={[-18.7378, 3.3247, 140.2939]}
        scale={[0.01, 0.01, 0.01]}
      />
    </group>
  );
}
